import styled from 'styled-components';
import breakpoint from 'Styles/breakpoints';
import UpsellCollectionOriginal from '../UpsellCollection/UpsellCollection';
import OverlayModal from '../ContentSystem/components/OverlayModal/OverlayModal';
import { Content as ModalContent } from '../Modal/Modal.styled';

export const Modal = styled(OverlayModal)`
  ${ModalContent} {
    overflow: hidden;
  }
`;

export const Container = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;

  ${breakpoint('medium')} {
    height: 740px;
  }
`;

export const PanelContainer = styled.div`
  padding: 24px 16px;
`;

export const UpsellCollection = styled(UpsellCollectionOriginal)`
  margin-top: 32px;
`;

export default {};
